import { MessageCircle, Mail, Camera } from "lucide-react";
import { business, waLink } from "../config/business";
import { useLanguage } from "../i18n/LanguageContext";

export const ContactSideCard = () => {
  const { t } = useLanguage();

  return (
    <div className="card-elevated relative flex h-full flex-col justify-center gap-4 overflow-hidden rounded-3xl p-7 sm:p-8">
      <div className="pointer-events-none absolute -right-20 -top-20 h-56 w-56 rounded-full bg-amber-400/10 blur-3xl" />
      <p className="relative font-mono text-xs uppercase tracking-widest text-amber-400/90">{business.hours}</p>
      <a data-testid="contact-whatsapp-cta" href={waLink(t.contact.waMessage)} target="_blank" rel="noopener noreferrer" className="btn btn-wa rounded-2xl px-6 py-4 text-base">
        <MessageCircle className="h-5 w-5" strokeWidth={2.5} />
        {t.contact.whatsappCta}
      </a>
      <a data-testid="contact-whatsapp-photos-cta" href={waLink(t.contact.waPhotoMessage)} target="_blank" rel="noopener noreferrer" className="btn btn-sky rounded-2xl px-6 py-4 text-base">
        <Camera className="h-5 w-5" strokeWidth={2.5} />
        {t.contact.photosCta}
      </a>
      <a data-testid="contact-email-cta" href={`mailto:${business.email}`} className="btn btn-ghost rounded-2xl px-6 py-4 text-base">
        <Mail className="h-5 w-5" strokeWidth={2.5} />
        {t.contact.emailCta}
      </a>
      <div className="relative mt-2 space-y-1 text-center font-mono text-sm text-slate-400">
        <p data-testid="contact-whatsapp-number">WhatsApp: {business.phoneDisplay}</p>
        <p data-testid="contact-email-text">{business.email}</p>
      </div>
    </div>
  );
};
